// import { AddressCorrectionType, ProviderSelection } from '@services/case/models';
import { AddressCorrectionType, ProviderSelection } from '../../../src/services/case/models';
// import { NoticeOfAdmission } from '@services/noa/models';
import { NoticeOfAdmission } from '../../../src/services/noa/models';

export interface DataGathering {
	dataGatheringScreen: string | null;
	isLoading: boolean;
}

export enum DataGatheringId {
	ClinicalFileUpload = 'ClinicalFileUpload',
	ClinicalUploadandFax = 'ClinicalUploadandFax',
	ProviderSelections = 'ProviderSelections',
	EnhancedProviderSelection = 'EnhancedProviderSelection',
	NotificationOfAdmission = 'NotificationOfAdmission',
	ContinuedStayReview = 'ContinuedStayReview',
	ExternalActionRequired = 'ExternalActionRequired',
	FHIRClinicalAttestation = 'FHIRClinicalAttestation',
	RetroRequestCorrection = 'RetroRequestCorrection',
	SurveyUrl = 'SurveyUrl',
	HtmlSurvey = 'HtmlSurvey',
	None = 'None',
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-wrapper-object-types
export interface DefaultDataGatheringInitializationData extends Object {
	// if we ever have universal initialization data, it would go here.
}

export interface NoticeOfAdmissionInitialData extends DefaultDataGatheringInitializationData {
	// V1
	admissionTime: string;
	diagnosis: string;
	//V2
	defaultCpt: string;
	diagnosisCode: string;
	fromDate: string;
	toDate: string;
	contactName: string;
	contactPhone: string;
}

export interface ClinicalFileUploadInitialData extends DefaultDataGatheringInitializationData {
	fileLimits: ClinicalFileLimits;
	contactDetailRequests: ContactDetailRequests;
	contactDetail: ContactDetail;
	isOptional: boolean;
	benefitManagerNotes: string;
}

export interface ExternalActionInitialData extends DefaultDataGatheringInitializationData {
	benefitManagerNote: string;
	externalActionUrl: string;
}

export interface ProviderSelectionInitializationData
	extends DefaultDataGatheringInitializationData {
	renderingProviders: ProviderSelection[];
	orderingProviders: ProviderSelection[];
	renderingFacilities: ProviderSelection[];
}

export interface EnhancedProviderSelectionInitialData
	extends DefaultDataGatheringInitializationData {
	addressType: AddressCorrectionType;
	expressProviderSelection: boolean;
}

export interface FHIRClinicalAttestationInitialData
	extends DefaultDataGatheringInitializationData,
		SdgFhirClinicalAttestationResponse {
	// fields already in extended interfaces
}

export interface SurveyUrlInitialData extends DefaultDataGatheringInitializationData {
	surveyUrl: string;
	windowEventHandlerId: string;
}

export const enum WindowEventHandlerIds {
	FinishSubmitPriorAuth = 'FINISH_SUBMIT_PRIOR_AUTH',
}

export interface HtmlSurveyInitialData extends DefaultDataGatheringInitializationData {
	htmlSurveyUrl: string;
}

export type InitialDataType =
	| NoticeOfAdmissionInitialData
	| ClinicalFileUploadInitialData
	| ExternalActionInitialData
	| ProviderSelectionInitializationData
	| EnhancedProviderSelectionInitialData
	| FHIRClinicalAttestationInitialData
	| SurveyUrlInitialData
	| HtmlSurveyInitialData;

export interface DataGatheringRequiredResponse {
	dataGatheringScreen: DataGatheringId;
	dataGatheringScreenInitializationData?: InitialDataType;
	submissionId: string;
	requestingEntity?: string;
	organizationId?: string;
	caseId?: string;
	pk?: string;
}

export interface ClinicalFileLimits {
	individualFileSizeMB: number;
	numberOfFiles: number;
	supportedFileTypes: Array<string>;
}

export interface SubmitData {
	fileIdentifiers: Array<string>;
	contactDetail: ContactDetail;
	orderingProvider: ProviderSelection;
	renderingFacility: ProviderSelection;
	renderingProvider: ProviderSelection;
	skipClinical: boolean;
	questionnaireResponse: FHIRQuestionnaireResponse;
	resultError: boolean;
	noticeOfAdmission: NoticeOfAdmission;
}

export interface SdgSubmit {
	dataGatheringScreen: DataGatheringId;
	submittedData: Partial<SubmitData>;
}

export interface ContactDetail {
	name?: string;
	phone?: string;
	fax?: string;
}

export interface ContactDetailRequests {
	needsPhone: boolean;
	needsFax: boolean;
	needsName: boolean;
}

export interface FHIRQuestionnaireResponse {
	item: any[];
	id: string;
}

export const enum ProviderTypes {
	ORDERING_PROVIDER = 'orderingProvider',
	RENDERING_FACILITY = 'renderingFacility',
	RENDERING_PROVIDER = 'renderingProvider',
}

export interface AddressChangeRequest {
	npi?: string;
	address?: string;
	firstName?: string;
	lastName?: string;
	name?: string;
	limit?: number;
	offset?: number;
	taxId?: string;
	searchAllOrganizationTypes: boolean;
	city?: string;
	state?: string;
	zip?: string;
}
export interface SdgFhirClinicalAttestationResponse {
	continuationUrl?: string; // the endpoint called to save QuestionnaireResponse data and possibly get more questions
	fhirQuestionnaire: string;
	resultError?: boolean;
}
